import React, { ChangeEvent, FC, memo, useRef, useEffect, useState } from 'react';
import { getChannelInfo} from '@utils/channel-util';
import AcSwipe from 'ac-components/ac-swiper';
import { USER_AGREEMENT, PRIVACY_POLICY } from 'constants/url';
import classnames from 'classnames';
import { useTranslation } from 'hooks/use-translation';
import { Swiper } from 'swiper/types';
import Button from 'ac-components/ac-btn';
import Input from 'ac-components/ac-ipt';
import Modal from 'ac-components/modal';
import { toast } from 'components/dialogs';
import Select, { Option } from 'components/select';
import useResizeObserver from 'hooks/use-resize-observer';
import AreaSelect, { Area } from 'containers/ac-containers/area-select';
import { fetchApplyTutor } from '@services/appointment';
import styles from './styles.scss';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';
import qs from 'qs';
import $ from 'jquery';
type IProps = {
	onClick?: () => void;
}
type AreaCodeItem = {
	code: string;
	text: string;
};
/**
 * 接口请求传输
 *
 * @interface IFormDataParams
 */
 interface IFormDataParams {
	code: string;
	keyword: string;
	gradeCode: string;
	subjectCode: string;
	areaCode: string | number;
	areaText: string;
	firstName: string;
	phone: string;
}
const RatingSection: FC<IProps> = (props) => {
	const { width } = useResizeObserver();
	const swiperRef = useRef<any>(null);
	const evaluation = [
		{
			id: 1,
			img: 'https://web-data.zmlearn.com/image/dtBaovsENRGNYe6hwH8BwV/image1.png',
			list: {
				title: "GCSE",
				info: "GCSE考试时间长度为两年，最后一门考试一般在高一的时候完成。",
				subjects: "热门科目",
				detail: "GCSE考试的成绩很大程度影响了A Level考试的成绩，许多大学预科班或者继续教育学院都会要求学生至少通过GCSE的五门考试，GCSE的考试成绩也会最终决定学生所就读的大学。",
				courseList: ['Maths','English Language','English Literature','Science','...']
			}
		},
		{
			id: 2,
			img: 'https://web-data.zmlearn.com/image/ftMbcuUFEagymZ8BEAP68R/image2.png',
			list: {
				title: "A-Levels",
				info: "A-Levels有超过40门科目，为了参加A-Levels考试，学生一般会被要求完成至少五门GCSE考试。",
				subjects: "热门科目",
				detail: "英国顶尖大学的录取一般会以A-Levels的成绩作为参考。例如有些要求学生申请之前要达到A*AA或者AAB的成绩。",
				courseList: ['Mathematics','Biology','Chemistry','History','Psychology','...']
			}
		},
		{
			id: 3,
			img: 'https://web-data.zmlearn.com/image/bbBLAyCyeHZyVpEF2v1wJ6/image3.png',
			list: {
				title: "大学入学考试准备",
				info: "顶尖大学和学院(例如牛津大学)在要求满足A-Levels成绩要求的同时，还会要求学生参加入学考试。考试的模式在学校和科目之间差异很大。",
				subjects: "特殊入学考试",
				detail: "一般来说，入学考试会考察学生所申请科目的知识点，也会进行常规的态度和意识测试。英国最优秀和顶尖的大学常常还会对申请者进行面试。",
				courseList: ['MAT','BMAT','PAT','...']
			}
		}
	];
	const demo = (index?: number) => {
		switch(index) {
			case(0): return <><p className={styles['courseList']}>Maths</p><p className={styles['courseList']}>English Language</p><p className={styles['courseList']}>English Literature</p><p className={styles['courseList']}>Science</p><p className={styles['courseList']}>...</p></>;
			case(1): return <><p className={styles['courseList']}>Mathematics</p><p className={styles['courseList']}>Biology</p><p className={styles['courseList']}>Chemistry</p><p className={styles['courseList']}>History</p><p className={styles['courseList']}>Psychology</p><p className={styles['courseList']}>...</p></>;
			default: return <><p className={styles['courseList']}>MAT</p><p className={styles['courseList']}>BMAT</p><p className={styles['courseList']}>PAT</p><p className={styles['courseList']}>...</p></>;
		}
	}
	const itemList = (evaluation as any[]).map((item, index) => {
		return (
			<div className={classnames(styles['ac-home-comment-item'], styles[`ac-home-comment-item-${item.id}`], `ac-home-comment-item-${item.id}`)} key={index}>
				<div className={styles['ac-home-comment-item-context']}>
					<h2>{item.list.title}</h2>
					<p className={styles['text']}>{item.list.info}</p>
					<p className={styles['subjects']}>{item.list.subjects}</p>
					<div>{demo(index)}</div>
					<p className={styles['detail']}>{item.list.detail}</p>
				</div>
			</div>
		);
	});
	const phoneBetween = width < 768 ? 16 : 24;
	const spaceBetween = width >= 1191 ? 32 : phoneBetween;
	return (
		<section className={styles['ac-home-comment']}>
			<div className={styles['ac-home-comment-container']}>
				<div className={styles['comment-wrap']}>
					<h1 className={styles['first']}>AirClass<br/>金牌一对一国际课程</h1>
					<h1 className={styles['second']}>AirClass金牌一对一国际课程</h1>
				</div>
				{width<1192? <AcSwipe
					className={classnames(styles['ac-home-comment-banner'], 'ac-home-comment-banner')}
					spaceBetween={spaceBetween}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					onSwiper={(swiper: Swiper) => {
						swiperRef.current = swiper;
					}}
					loop={ true }
					slidesPerView={width >= 1192 ? 1 : 'auto'}
					allowTouchMove={width < 1192}
					pagination={width >= 1192 ? {
						clickable: true,
					} : true}>
					{itemList}
				</AcSwipe>:<AcSwipe
					className={classnames(styles['ac-home-comment-banner'], 'ac-home-comment-banner')}
					spaceBetween={spaceBetween}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					onSwiper={(swiper: Swiper) => {
						swiperRef.current = swiper;
					}}
					slidesPerView={width >= 1192 ? 3 : 'auto'}
					allowTouchMove={width < 1192}
					pagination={width >= 1192 ? {
						clickable: true,
					} : true}>
					{itemList}
				</AcSwipe>}
			</div>
		</section>
	);
};
const CommentsSection: FC = () => {
	const { width } = useResizeObserver()
	const list = [
		{
			id: 1,
			name: `Mazzy 老师`,
			university: `剑桥大学`,
			content: `Mazzy老师在玛丽女王学院学习英国文学，在剑桥大学获得了历史学硕士学位。目前，她同时教授A Level及以下的英语文学、历史和政治。`,
		},
		{
			id: 2,
			name: `Laurence 老师`,
			university: `布里斯托大学`,
			content: `Laurence老师有辅导GCSE, A- Level考试数学科目，以及大学统计学课程的经验。目前，她也是一位经济学博士候选人。`,
		},
		{
			id: 3,
			name: `Ben 老师`,
			university: `贝尔法斯特女王大学`,
			content: `Ben有将近30年的教学经验。他帮助多名学生申请到了英国伊顿公学、威斯敏斯特皇家书院等著名私校。 `,
		},
		{
			id: 4,
			name: `Jacob 老师`,
			university: `牛津大学`,
			content: `Jacob老师擅长教学A-Level的生物和物理课程，以及牛津大学的MAT和BMAT入学考试辅导。因有趣、专业的教学风格而深受学生喜爱。 `,
		},
		{
			id: 5,
			name: `Shanie 老师`,
			university: `利兹大学`,
			content: `Shanie老师在利兹大学经济学系毕业后，曾在著名的咨询公司就职。出于对学生的喜爱，她转而成为了一名学习规划专家，帮助无数学生进入心仪的大学。 `,
		},
		{
			id: 6,
			name: `Riutta 老师`,
			university: `爱丁堡大学`,
			content: `Riutta在爱丁堡大学获得社会学学位，拥有丰富的国际组织和公共事务工作经验。她教授科目包括心理学、历史等，并帮助学生进行社会学科的大学申请。 `,
		}
	];
	const ListRender = list.map((item, index) => {
		return (
			<div className={classnames(styles['ac-comment-item'], styles[`ac-comment-item-${item.id}`], `ac-comment-item-${item.id}`)} key={index}>
				<div className={styles['ac-comment-avatar']}>{item.name}</div>
				<p className={styles['ac-comment-university']}>{item.university}</p>
				<div className={styles['ac-comment-item-context']}>{item.content}</div>
			</div>)
	})
	const padding = width >= 768 ? 24 : 16
	return (
		<section className={styles['ac-tutors-section']}>
			<div className={styles['ac-tutors-container']}>
				<h1>名师一览</h1>
				<AcSwipe className={classnames(styles['ac-tutors-banner'], 'ac-tutors-banner')}
					loop
					spaceBetween={width >= 1192 ? 32 : padding}
					pagination={width >= 1192 ? {
						clickable: true,
					} : true}
					autoplay={{
						delay: 5000,
						disableOnInteraction: false,
					}}
					slidesPerGroup={width >= 768 ? 1 : 1}
					loopFillGroupWithBlank={width >= 768}
					slidesPerView={width >= 768 ? 3 : 'auto'}
				>{ListRender}</AcSwipe>
			</div>
		</section >
	);
}
const projectList = [{label:'A-Level',value:'A-Level'},{label:'IGCSE',value:'IGCSE'},{label:'13+',value:'13+'},{label:'11+',value:'11+'},{label:'雅思',value:'雅思'},{label:'托福',value:'托福'}];
(() => {
	const script = document.createElement('script');
	script.setAttribute('type', 'text/javascript');
	script.setAttribute('src', 'https://statics-lib.zmlearn.com/jquery/1.12.4/jquery-1.12.4.min.js');
	script.setAttribute('src', 'https://statics-lib.zmlearn.com/geetest/1.0.0/gt.js');
	document.getElementsByTagName('head')[0].appendChild(script);
	script.onload = function () {
		$(function(){
			$("#why2-swipper>div").click(function(){
				$(this).width(580); // 改变当前元素兄弟元素的宽度
				$(this).siblings().width(153);
				$(this).find('h2').fadeIn(500);
				$(this).find('p').fadeIn(500);
				$(this).siblings().find('h2').css({display: 'none'});
				$(this).siblings().find('p').css({display: 'none'});
			});
		})
	}
})();

const FreeForm: FC = (props: any) => {
	const { width } = useResizeObserver();
	const [isShow, setShow] = useState(false);
	const [learningList, setLearningList] = useState([
		{label: '数学',value: '数学'},
		{label: '经济学',value: '经济学'},
		{label: '生物学',value: '生物学'},
		{label: '化学',value: '化学'},
		{label: '物理学',value: '物理学'},
		{label: '历史学',value: '历史学'},
		{label: '计算机',value: '计算机'},
		{label: '地理学',value: '地理学'},
		{label: '哲学',value: '哲学'},
		{label: '英语',value: '英语'},
		{label: '心理学',value: '心理学'},
		{label: '西班牙',value: '西班牙'},
		{label: '德语',value: '德语'},
		{label: '法语',value: '法语'},
		{label: '意大利语',value: '意大利语'},
		{label: '其他科目',value: '其他科目'},
	]);
	const [offsetWidth, setWidth] = useState<string | number>(0);
	const { local, countryCode } = useSelector((state: ConnectState) => state.app);
	const [area, setArea] = useState<Area>();
	const [areaList, setAreaList] = useState<AreaCodeItem[]>([]);
	const [areaTip, setAreaTip] = useState<string>('');
	const [alertTip, setAlertTip] = useState<string>('');
	const [phoneTip, setPhoneTip] = useState<string>('');

	const checkRef = useRef<HTMLInputElement>(null);
	const initFormParams: IFormDataParams = {
		code: '',
		keyword: '',
		areaCode: '',
		areaText: '',
		firstName: '',
		phone: '',
		gradeCode: '',
		subjectCode: '',
	};
	const [formParams, setFormParams] = useState(initFormParams);
	const cardRef = useRef<HTMLDivElement | null>(null);
	function handleInputChange(key: string, val: string) {
		setFormParams({
			...formParams,
			[key]: val,
		});
	}

	/**
	 * 区域选择 项目 学科
	 * @param
	 */
	function onSelectChange(option: { code: string; text: string }, key: string){
		console.log(option, 'ok');
		const val = option.code;
		const newFormParams = {
			...formParams,
			[key]: val,
		};
		if (val == 'IGCSE') {
			setLearningList([
				{label: '数学',value: '1'},
				{label: '英语',value: '2'},
				{label: '科学',value: '3'},
				{label: '生物学',value: '4'},
				{label: '化学',value: '5'},
				{label: '物理学',value: '6'},
				{label: '心理学',value: '7'},
				{label: '其他科目',value: '8'}
			]);
		}
		if (val == '13+') {
			setLearningList([
				{label: '数学',value: '1'},
				{label: '英语',value: '2'},
				{label: '科学',value: '3'},
				{label: '地理学',value: '4'},
				{label: '历史',value: '5'},
				{label: '西班牙',value: '6'},
				{label: '德语',value: '7'},
				{label: '法语',value: '8'}]
			);
		}
		if (val == '11+') {
			setLearningList([
				{label: '数学',value: '1'},
				{label: '英语',value: '2'},
				{label: '非言语推理',value: '3'},
				{label: '言语推理',value: '4'},
			]);
		}
		if (val == '雅思') {
			setLearningList([
				{label: '雅思1对1',value: '1'}
			]);
		}
		if (val == '托福') {
			setLearningList([
				{label: '托福1对1',value: '1'}
			]);
		}
		if (key === 'areaCode') {
			newFormParams.areaText = option.text as string;
		}
		setFormParams(newFormParams);
	}
	// 选择国家地区
	const onAreaChange = (item: Area) => {
		setArea(item);
		setFormParams({
			...formParams,
			areaCode: item.code,
		});
		setAreaTip('');
	};
	// 输入号码
	const onPhoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		handleInputChange('phone', e.target.value);
		setPhoneTip('');
		setAlertTip('');
	};
	useEffect(() => {
		if (cardRef.current) {
			setWidth(cardRef.current.offsetWidth);
		}
	}, [cardRef.current]);
	const [height2, setHeight] = useState(0);
	useEffect(() => {
		const app = document.getElementById('app');
		const handleScroll = () => {
			if (app) {
				const scrollTop = app.scrollTop;
				const banner = document.getElementById('banner');
				const banner2 = document.getElementById('banner2');
				const header = document.getElementById('header');
				const header2 = document.getElementById('header2');
				if ( scrollTop > 5 && banner2 && banner && header2 && header) {
					const opa = scrollTop/50;
					// banner2.style.opacity = `${opa}`;
					// banner.style.opacity = '0';
					// header2.style.opacity = `${opa}`;
					// header.style.opacity = '0';
				} else {
					// banner.style.opacity = '1';
					// banner2.style.opacity = '0';
					// header.style.opacity = '1';
					// header2.style.opacity = '0';
				}
			}
		}
		if (app) {
			app.addEventListener('scroll', handleScroll);
		}
		return () => window.removeEventListener('scroll', handleScroll);
	},[]);
	useEffect(() => {
		const height = document.body.clientHeight;
		setHeight(height);
	});
	function prepareButton() {
		setShow(!isShow);
		formParams.gradeCode = '';
		formParams.subjectCode = '';
	}
	function closeBtn() {
		setShow(false);
	}

	/**
	 * 预约注册
	 */
	const CID = 11;
	async function handleSubmit() {
		// 表单校验
		if (!formParams.firstName) {
			return toast({ message: "请填写姓名！" });
		}
		if (!formParams.gradeCode) {
			return toast({ message: '请选择备战项目!'});
		}
		if (!formParams.subjectCode) {
			return toast({ message: '请选择学科!' });
		}
		if (!formParams.phone) {
			return toast({ message: "请填写手机号！" });
		}
		if (!checkRef.current?.checked) {
			return toast({ message: "请同意用户协议和隐私政策！" });
		}

		/* 区分华侨 */
		const { channel_code, channel_keyword } = getChannelInfo(countryCode);
		const query = qs.parse(window.location.href.split('?')[1], { ignoreQueryPrefix: true });
		if (query.channel_code || query.channelcode) {
			formParams.code = query.channel_code || query.channelcode;
		} else {
			formParams.code = channel_code;
		}
		if (query.channel_keyword || query.channelkey) {
			formParams.keyword = query.channel_keyword || query.channelkey;
		} else {
			formParams.keyword = channel_keyword;
		}
		fetchApplyTutor(CID,
			{
				code: formParams.code,
				key: formParams.keyword,
				name: formParams.firstName,
				mobile: formParams.phone,
				gradeCode: formParams.gradeCode,
				subjectCode: formParams.subjectCode,
				areaCode: formParams.areaCode,
			}
		).then((res) => {
			setShow(false);
			toast({
				message: '提交成功！',
			});
		}).catch((err) => {
			setShow(false);
			toast({
				message: err.message || '网络错误',
			});
		});
	}
	return (
		<div className={styles['abroad-website']}>
			<div className={styles['banner-container']} style={{height: `${height2-52}px`}}>
				<div className={styles['banner']} id="banner" style={{height: `${height2-52}px`,opacity: 1}}>
					<div className={styles['text']}>
						<span>来自英国本土的</span>个性化英伦教育品牌
					</div>
					<h1>AirClass 1-on-1</h1>
					<div className={styles['info']}>
						<p>覆盖A-Level/GCSE所有学科</p>
						<p>来自英国私校的专业教研力量</p>
						<p>10,000+英国本土教师</p>
						{/* <button className={styles['prepare-btn']} onClick={prepareButton}>一键备战</button> */}
					</div>
					<img className={styles['circle']} src="https://web-data.zmlearn.com/image/7drythX5LdCyWXEzRJox7/circle.png" alt="" width={244} height={244} loading='lazy'/>
					<img className={styles['student']} src="https://web-data.zmlearn.com/image/nh4Zysc2DAV623XKwKoiXB/student.png" alt="" width={254} height={381} loading='lazy'/>
				</div>
				<div className={styles['banner2']} id="banner2" style={{height: `${height2-52}px`}}>
					<button className={styles['prepare-btn']} onClick={prepareButton}>一键备战</button>
					{/* <div className={styles['text']}>来自英国本土的个性化英伦教育品牌</div>
					<h1>AirClass 1-on-1</h1>
					<div className={styles['info']}>
						<p>覆盖A-Level/GCSE所有学科</p>
						<p>10,000+英国本土教师</p>
						<button className={styles['prepare-btn']} onClick={prepareButton}>一键备战</button>
					</div>
					<img className={styles['student2']} src="https://web-data.zmlearn.com/image/6UEAfx8sgFKsg5MW1Nw32B/student2.png" width={507} height={762} loading='lazy'/> */}
					<div className={styles['choose-school']}>
						<div className={styles['level']}>
							<h1>01</h1>
							<p>A-Level/GCSE选科指导</p>
						</div>
						<div className={styles['line']}> / </div>
						<div className={styles['level']}>
							<div className={styles['level-cont']}>
								<h2 className={styles['level-cont-txt']}>02<i className={styles['crown']}></i></h2>
							</div>
							<p>GCSEs全科辅导</p>
						</div>
						<div className={styles['line']}> / </div>
						<div className={styles['level']}>
							<h1>03</h1>
							<p>A-Level全A冲刺</p>
						</div>
						<div className={styles['line']}> / </div>
						<div className={styles['level']}>
							<h1>04</h1>
							<p>大学入学考试辅导</p>
						</div>
					</div>
				</div>
			</div>
			<div className={styles['header-container']}>
				<div className={styles['header']} id="header" style={{opacity: 1}}>
					<div className={styles['container']}>
						<div className={styles['left']}>
							<h2><strong>来自英国本土的</strong>个性化英伦教育品牌</h2>
							<h1>AirClass 1-on-1</h1>
							<p className={styles['text']}>覆盖A-Level/GCSE所有学科</p>
							<p className={styles['text']}>来自英国私校的专业教研力量</p>
							<p className={styles['text']}>10,000+英国本土教师</p>
							{/* <button className={styles['prepare-button']} onClick={prepareButton}>一键备战</button> */}
						</div>
						<div className={styles['right']}>
							<img className={styles['girl']} src='https://web-data.zmlearn.com/image/qFC5JaEakB3BgdekZwjkH/girl.png' width={415} height={620}/>
							<img className={styles['circle2']} src='https://web-data.zmlearn.com/image/bmD9V7AjXYuRwbLMhSAXnp/circle2.png' width={376} height={376}/>
						</div>
					</div>
				</div>
				<div className={styles['header2']} id="header2">
					<div className={styles['container']}>
						{/* <div className={styles['girl']}></div>
						<div className={styles['left']}>
							<h2><span>来自英国本土的</span>个性化英伦教育品牌</h2>
							<h1>AirClass 1-on-1</h1>
							<p className={styles['text']}>覆盖A-Level/GCSE所有学科</p>
							<p className={styles['text']}>10,000+英国本土教师</p>
							<button className={styles['prepare-button']} onClick={prepareButton}>一键备战</button>
						</div> */}
						<button className={styles['prepare-button']} onClick={prepareButton}>一键备战</button>
						<div className={styles['steps']}>
							<div className={styles['step']}>
								<h3>01</h3>
								<p>A-Level/GCSE选科指导</p>
								<div className={styles['line']}></div>
							</div>
							<div className={styles['step2']}>
								<h3>02</h3>
								<p>GCSEs全科辅导</p>
								<i className={styles['crown']}></i>
								<div className={styles['line']}></div>
							</div>
							<div className={styles['step']}>
								<h3>03</h3>
								<p>A-Level全A冲刺</p>
								<div className={styles['line']}></div>
							</div>
							<div className={styles['step']}>
								<h3>04</h3>
								<p>大学入学考试辅导</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className={styles['service']}>
				<h1 className={styles['first']}>AirClass<br/>留学英伦专项服务</h1>
				<h1 className={styles['second']}>AirClass留学英伦专项服务</h1>
				<div className={styles['container01']}>
					<div className={styles['position']}>
						<i className={styles['icon']}></i>
					</div>
					<div className={styles['describe']}>
						<div className={styles['tips']}>Service 01</div>
						<div className={styles['title']}>选科指导</div>
						<div className={styles['text']}>我们经验丰富的英国顾问对英国大学和专业的申请需求了如指掌。我们将根据您的想法，为您量身打造最合适的学科方案。</div>
					</div>
				</div>
				<div className={styles['container02']}>
					<div className={styles['tutoring']}>
						<i className={styles['icon']}></i>
					</div>
					<div className={styles['describe']}>
						<div className={styles['tips']}>Service 02</div>
						<div className={styles['title']}>GCSEs备战辅导</div>
						<div className={styles['text']}>GCSE是大学入学考试的前期基础，我们的老师会帮助学生提升其学术成绩，并发掘孩子的潜力，给予未来A-Level学习的建议和帮助。</div>
					</div>
				</div>
				<div className={styles['container03']}>
					<div className={styles['course']}>
						<i className={styles['icon']}></i>
					</div>
					<div className={styles['describe']}>
						<div className={styles['tips']}>Service 03</div>
						<div className={styles['title']}>A-Level全A冲刺</div>
						<div className={styles['text']}>A-Levels是英国、新加披等英联邦教育体系下的大学考试核心标准，AirClass专注于帮助学生攻克每个难题，冲刺A*。</div>
					</div>
				</div>
			</div>
			<RatingSection />
			<div className={styles['why']}>
				<h1>为什么选择AirClass</h1>
				<div className={styles['why-text']}>
					<img src="https://web-data.zmlearn.com/image/2EzwdCa16QoDo1gUhNejbV/icon1.png" alt="" width={50} height={50} />
					<h2>AirClass是来自英国本土的<br/>教育咨询机构</h2>
					<p>自2014年以来，AirClass致力于为英国和海外的学生提供咨询和求学支持。</p>
				</div>
				<div className={styles['experience']}>
					<img src="https://web-data.zmlearn.com/image/74tKdif5fhB5sdRP54vriL/icon2.png" alt="" width={50} height={50} />
					<h2>拥有多年教龄的UK本土老师<br/>在线1对1教学<br/>随时随地本地化体验</h2>
					<p>我们通过严格而系统的教师筛选流程，确保每一位家教和课后辅导老师都代表其教学领域的最高水平。老师都拥有多年英国教学体系下的教学实践经验，在其所在的领域享有良好声誉。</p>
				</div>
				<div className={styles['team']}>
					<img src="https://web-data.zmlearn.com/image/qHmq1pekYRrpHKHyy6R4Vd/icon3.png" alt="" width={50} height={50} />
					<h2>专业UK本地专家级<br/>教研教学团队</h2>
					<p>AirClass建立了广泛的教研和教师网络。这些教研专家包括来自牛津、剑桥、哈佛等世界知名大学的毕业生，拥有丰富的教学经验。教研资料覆盖全年级、60多门学科，产出20000+优质辅导课件。</p>
				</div>
				<div className={styles['experience']}>
					<img src="https://web-data.zmlearn.com/image/4CfmRT5YKAAfHfAA5RQ7HA/icon4.png" alt="" width={50} height={50} />
					<h2>提前体会英伦学习体验<br/>为留学生活做准备</h2>
					<p>自2014年以来，我们通过教育咨询及私人辅导服务帮助了无数学生进入心仪的学校。不同于传统辅导机构，我们不仅帮助学生备考GCSEs、A-Levels等入学考试，跟上学校的教学进度并提高学习成绩，我们还致力于为学生提供留学生活的准备支持，缩短了学生进入新环境的适应期。</p>
				</div>
				<div className={styles['customer']}>
					<img src="https://web-data.zmlearn.com/image/3qarNRxr4S5ESiT181etiK/icon5.png" alt="" width={50} height={50} />
					<h2>华人客服团队极速响应</h2>
					<p>我们会通过电话为您提供免费咨询服务。一旦我们对您的需求有了清晰的了解之后，我们会代表您匹配并联系到最适合您的导师，并且制定授课计划。</p>
					<p>为了在中国的学生提供更高的服务体验，我们拥有专业的华人客服团队，帮助学生和导师建立最紧密的联系，保障学生的学习质量。</p>
				</div>
			</div>
			<div className={styles['why2']}>
				<div className={styles['why2-container']}>
					<h2 className={styles['title']}>为什么选择AirClass</h2>
					<div className={styles['why2-swipper']} id="why2-swipper">
						<div>
							<img src="https://web-data.zmlearn.com/image/2EzwdCa16QoDo1gUhNejbV/icon1.png" alt="" width={50} height={50} />
							<h2>AirClass是来自英国本土的<br/>教育咨询机构</h2>
							<p>自2014年以来，AirClass致力于为英国和海外的学生提供咨询和求学支持。</p>
						</div>
						<div>
							<img src="https://web-data.zmlearn.com/image/74tKdif5fhB5sdRP54vriL/icon2.png" alt="" width={50} height={50} />
							<h2>拥有多年教龄的UK本土老师<br/>在线1对1教学<br/>随时随地本地化体验</h2>
							<p>我们通过严格而系统的教师筛选流程，确保每一位家教和课后辅导老师都代表其教学领域的最高水平。老师都拥有多年英国教学体系下的教学实践经验，在其所在的领域享有良好声誉。</p>
						</div>
						<div>
							<img src="https://web-data.zmlearn.com/image/qHmq1pekYRrpHKHyy6R4Vd/icon3.png" alt="" width={50} height={50} />
							<h2>专业UK本地专家级<br/>教研教学团队</h2>
							<p>AirClass建立了广泛的教研和教师网络。这些教研专家包括来自牛津、剑桥、哈佛等世界知名大学的毕业生，拥有丰富的教学经验。教研资料覆盖全年级、60多门学科，产出20000+优质辅导课件。</p>
						</div>
						<div>
							<img src="https://web-data.zmlearn.com/image/4CfmRT5YKAAfHfAA5RQ7HA/icon4.png" alt="" width={50} height={50} />
							<h2>提前体会英伦学习体验<br/>为留学生活做准备</h2>
							<p>自2014年以来，我们通过教育咨询及私人辅导服务帮助了无数学生进入心仪的学校。不同于传统辅导机构，我们不仅帮助学生备考GCSEs、A-Levels等入学考试，跟上学校的教学进度并提高学习成绩，我们还致力于为学生提供留学生活的准备支持，缩短了学生进入新环境的适应期。</p>
						</div>
						<div>
							<img src="https://web-data.zmlearn.com/image/3qarNRxr4S5ESiT181etiK/icon5.png" alt="" width={50} height={50} />
							<h2>华人客服团队极速响应</h2>
							<p>我们会通过电话为您提供免费咨询服务。一旦我们对您的需求有了清晰的了解之后，我们会代表您匹配并联系到最适合您的导师，并且制定授课计划。</p>
							<p>为了在中国的学生提供更高的服务体验，我们拥有专业的华人客服团队，帮助学生和导师建立最紧密的联系，保障学生的学习质量。</p>
						</div>
					</div>
				</div>
				<button className={styles['btn']} onClick={prepareButton}>立即咨询</button>
			</div>
			<div className={styles['consulting']}>
				<button className={styles['btn']} onClick={prepareButton}>立即咨询</button>
			</div>
			<CommentsSection />
			<div className={styles['appointment']}>
				<h1 className={styles['first']}>1对1在线课程<br/>预约流程</h1>
				<h1 className={styles['second']}>1对1在线课程预约流程</h1>
				<div className={styles['appointment-content']}>
					<div className={styles['steps']}>
						<div className={styles['step-one']}>
							<i className={styles['icon']}></i>
							<h1>Step 1</h1>
							<p className={styles['first']}>填写您的需求信息，咨询顾问会在<br/>24小时内与您联系</p>
							<p className={styles['second']}>填写您的需求信息，咨询顾问会在24小时内<br/>与您联系</p>
							<i className={styles['arrow01']}></i>
						</div>
						<div className={styles['step-two']}>
							<i className={styles['icon']}></i>
							<h1>Step 2</h1>
							<p className={styles['first']}>根据电话咨询，为您匹配合适的老师<br/>并和您确定第一节课的试听时间</p>
							<p className={styles['second']}>根据电话咨询，为您匹配合适的老师并和您<br/>确定第一节课的试听时间</p>
							<i className={styles['arrow02']}></i>
						</div>
						<div className={styles['step-three']}>
							<i className={styles['icon']}></i>
							<h1>Step 3</h1>
							<p>开始我们的第一节课程</p>
						</div>
						<img className={styles['img']} src="https://web-data.zmlearn.com/image/5PsiWBvm8JiNfa56Lyvm9N/steps.png" width={580} height={728} />
						<button className={styles['immediately-btn2']} onClick={prepareButton}>立即预约</button>
					</div>
				</div>
				<button className={styles['immediately-btn']} onClick={prepareButton}>立即预约</button>
			</div>
			<div className={styles['commitment']}>
				<h1 className={styles['one']}>4大承诺<br/>保障您的留学旅程</h1>
				<h1 className={styles['two']}>4大承诺保障您的留学旅程</h1>
				<div className={styles['journey']}>
					<ul>
						<li>
							<img src="https://web-data.zmlearn.com/image/n9w969dG7VNUVQgA681J3w/audition.png" alt="" width={40} height={40}/>
							<h3>免费试听</h3>
							<p>第一节课不收取任何费用</p>
						</li>
						<li>
							<img src="https://web-data.zmlearn.com/image/sEK5F7sRnj4ifTbjTzCVvr/class.png" alt="" width={40} height={40}/>
							<h3>随时约课</h3>
							<p>课堂可以随时预约和取消</p>
						</li>
					</ul>
					<ul>
						<li>
							<img src="https://web-data.zmlearn.com/image/k8q2qP78CVmt2bdNBSB72s/teacher.png" alt="" width={40} height={40}/>
							<h3>免费换老师</h3>
							<p>对老师不满意免费更换</p>
						</li>
						<li>
							<img src="https://web-data.zmlearn.com/image/gAayVeJruPsvCeiGa4sMiL/refund.png" alt="" width={40} height={40}/>
							<h3>无忧退款</h3>
							<p>对课程不满意14日内免费退</p>
						</li>
					</ul>
					<div className={styles['journey-container']}>
						<div className={styles['content']}>
							<div className={styles['header']}><img src="https://web-data.zmlearn.com/image/96cr8sUXswW4wDGiXaquYD/free.png" alt="" width={70} height={70}/></div>
							<h4>免费试听</h4>
							<p>第一节课不收取任何费用</p>
						</div>
						<div className={styles['content']}>
							<div className={styles['header']}><img src="https://web-data.zmlearn.com/image/x872mpnp3c4e7vjhnhpak/class.png" alt="" width={70} height={70}/></div>
							<h4>随时约课</h4>
							<p>课堂可以随时预约和取消</p>
						</div>
						<div className={styles['content']}>
							<div className={styles['header']}><img src="https://web-data.zmlearn.com/image/o5WE3XeKW3AoBZ2DazfTWF/change.png" alt="" width={70} height={70}/></div>
							<h4>免费换老师</h4>
							<p>对老师不满意免费更换</p>
						</div>
						<div className={styles['content']}>
							<div className={styles['header']}><img src="https://web-data.zmlearn.com/image/oKQ73J8kF2zsqirEW5J1zL/refund.png" alt="" width={70} height={70}/></div>
							<h4>无忧退款</h4>
							<p>对课程不满意14日内免费退</p>
						</div>
					</div>
				</div>
			</div>
			<div className={styles['footer']}>
				<div className={styles['footer-container']}>
					<div className={styles['text']}>
						<img src="https://web-data.zmlearn.com/image/wwmWmsXW2eC4ioHjkZen2T/logo.png" alt="" width={172} height={21}/>
						<div className={styles['module']}>
							<h1>AirClass英国官网</h1>
							<p><a href="https://www.air-class.org" target='_blank'>www.air-class.org</a></p>
						</div>
						{/* <div className={styles['module']}>
							<a href="https://www.kidsafeseal.com/certifiedproducts/airclass.html" target='_blank'>
								<img className={styles['kids-img']} src='https://web-data.zmlearn.com/image/bD1hWEN6vc6NGVshwcaRVA/kids.png' width={172} height={58} />
							</a>
						</div> */}
					</div>
					<div className={styles['text']}>
						<h1>联系我们</h1>
						<p><i className={styles['mail']}></i>contact@air-class.com</p>
						<p><i className={styles['tel']}></i>+44 2032397887</p>
						<p><i className={styles['serve']}></i>service01@air-class.com</p>
					</div>
					<div className={styles['text']}>
						<div className={styles['module2']}>
							<h1>AirClass华人</h1>
							<p><a href="http://airclasskids.com/" target='_blank'>www.airclasskids.com</a></p>
						</div>
						<div className={styles['module']}>
							<h1>加入我们</h1>
							<p><i className={styles['mail']}></i>tutor@air-class.com</p>
						</div>
					</div>
				</div>
				<div className={styles['kids']}></div>
				<div className={styles['links']}>
					<a href="https://www.facebook.com/AirClassLa" target='_blank'><span className={styles['facebook']}></span></a>
					<a href="https://www.instagram.com/airclass_global/" target='_blank'><span className={styles['ins']}></span></a>
					<span className={styles['wechat']}>
						<div className={styles['qrcode']}>
							<img src="https://web-data.zmlearn.com/image/ogqcjqzQmPWz51aMu2AK92/footer_qrcode.png" loading="lazy" />
							<p>AirClass Kids</p>
							<span>cuentas oficiales de WeChat</span>
						</div>
					</span>
					<a href="https://twitter.com/airclassglobal" target='_blank'><span className={styles['twitter']}></span></a>
				</div>
			</div>
			<Modal onClose={closeBtn} show={isShow} className={classnames(styles['ac-modal'], 'ac-modal-free-form2')}>
				<div className={styles['ac-modal-wrap']}>
					<div className={styles['ac-modal-title']}>一对一课程咨询</div>
					<div className={classnames(styles['ac-modal-form'], 'ac-modal-form')}>
						<div className={styles.item_box}>
							<div className={styles['form-item']}>
								<label htmlFor="firstName">姓名</label>
								<Input
									className={styles['input']}
									placeholder="姓名"
									value=""
									size="large"
									onChange={(e: ChangeEvent<HTMLInputElement>) => handleInputChange('firstName', e.target.value)}
								/>
							</div>
						</div>
						<div className={styles.item_box}>
							<div className={styles['form-item']}>
								<label htmlFor="gradeCode">备战项目</label>
								<div className={styles.releative}>
									<Select
										className={styles['subject-select']}
										placeholder="备战项目"
										selected={{ value: formParams.gradeCode, label: '' }}
										onChange={(option: { value: any; label: any }) => onSelectChange({ code: option.value, text: option.label }, 'gradeCode')}
										allowSearch={false}
										size="large"
										zIndex={1000}
										showArrow={true}>
										{projectList.map((v) => {
											return (
												<Option value={v.value} key={v.value} option={{ ...v, label: v.label, value: v.value }}>
													{v.label}
												</Option>
											);
										})}
									</Select>
								</div>
							</div>
						</div>
						<div className={styles.item_box}>
							<div className={styles['form-item']}>
								<label htmlFor="subjectCode">学科</label>
								<div className={styles.releative}>
									<Select
										className={styles['subject-select']}
										placeholder="学科"
										selected={{ value: formParams.subjectCode, label: '' }}
										onChange={(option: { value: any; label: any }) => onSelectChange({ code: option.value, text: option.label }, 'subjectCode')}
										allowSearch={false}
										size="large"
										zIndex={1000}
										showArrow={true}>
										{learningList.map((v) => {
											return (
												<Option value={v.value} key={v.value} option={{ ...v, label: v.label, value: v.value }}>
													{v.label}
												</Option>
											);
										})}
									</Select>
								</div>
							</div>
						</div>
						<div className={styles.item_box}>
							<div className={styles['form-item']} ref={cardRef}>
								<label htmlFor="phone">手机号码</label>
								{(areaTip || phoneTip) && <div className={styles.verify_tip}>{areaTip || phoneTip}</div>}
								<Input
									className={styles.phoneNumber}
									placeholder="手机号码"
									onChange={onPhoneChange}
									type="number"
									prefix={<AreaSelect selected={area} onChange={onAreaChange} width={offsetWidth} />}
								/>
							</div>
						</div>
					</div>
					<div className={styles['ac-modal-footer']}>
						<div className={classnames(styles['agreement-box'], styles['agreement-content'])}>
							<input className={styles['check-box']} type="checkbox" ref={checkRef} value="#f0544d" id="check-box" />
							<label htmlFor="check-box"></label>
							<p>我已阅读并同意<a target="_blank" href={USER_AGREEMENT}>《用户协议》</a>和<a target="_blank" href={PRIVACY_POLICY}>《隐私政策》</a></p>
						</div>
						<Button className={styles['btn']} onClick={handleSubmit}>提交信息</Button>
					</div>
				</div>
			</Modal>
		</div>
	);
}
export default memo(FreeForm);
